import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../redux/store";
import { formatUscInsurancePrice, InsurancePriceLabelKey } from "../../../../utils/insuranceUtils";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import { getAemInsuranceRateFormat } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import { enableUscInsurance } from "../../../../utils/settings";
import List from "../../styles/atoms/List";
import LinkTextDisclaimer from "../LinkTextDisclaimer";
import DisclaimerIconWrapper from "../DisclaimerIconWrapper";
import * as BasketStyles from "./UscBasket.styles";

const UscInsurancePanel = (): JSX.Element | null => {
    const isActive = useUscSelector((state) => !!state.insurance.quote);
    const insurancePriceFormat = useUscSelector(({ commonSettings, vehicle }) =>
        getAemInsuranceRateFormat(commonSettings, AemFmComponent.Pdp, vehicle.type),
    );
    const { insurancePriceLabels } = useUscSelector(
        ({ insurance, commonSettings, uscSettings }) =>
            formatUscInsurancePrice(commonSettings, uscSettings, insurance.quote, insurancePriceFormat),
        shallowEqual,
    );
    const isInsuranceEnabled = useUscSelector(({ commonSettings, uscSettings, vehicle }) =>
        enableUscInsurance(commonSettings, uscSettings, vehicle.result, vehicle.type),
    );

    if (!isInsuranceEnabled || !isActive) return null;

    return (
        <List variant="basket-panel-list" data-testid="usc-insurancepanel">
            <li>
                {insurancePriceLabels.map(({ key, value }) => {
                    switch (key) {
                        case InsurancePriceLabelKey.InsuranceType:
                            return (
                                <Text variant="body-small-semibold" key={key}>
                                    {value}
                                </Text>
                            );

                        case InsurancePriceLabelKey.Price:
                            return (
                                <BasketStyles.InlineTextIcon key={key}>
                                    <Text variant="body-small-semibold">
                                        <span dangerouslySetInnerHTML={{ __html: value }} />
                                    </Text>
                                    <DisclaimerIconWrapper type={UscDisclaimerType.Insurance} />
                                </BasketStyles.InlineTextIcon>
                            );

                        case InsurancePriceLabelKey.CalculationId:
                            return (
                                <Text variant="body-small-regular" key={key}>
                                    {value}
                                </Text>
                            );

                        case InsurancePriceLabelKey.Disclaimer:
                            return <LinkTextDisclaimer type={UscDisclaimerType.Insurance} />;

                        default:
                            return null;
                    }
                })}
            </li>
        </List>
    );
};

export default UscInsurancePanel;
